import {
  AssociatedUsersRelationsKeys,
  AssociatedUsersRelationsProps
} from 'site/Renderer/components/Kanban/Kanban.types'

export default function filterAssociatedUsersRelations(
  relations: AssociatedUsersRelationsProps,
  configuredKeys: readonly AssociatedUsersRelationsKeys[]
): AssociatedUsersRelationsProps {
  return configuredKeys.reduce<AssociatedUsersRelationsProps>((acc, key) => {
    const relation = relations.find(({ relation }) => relation === key)

    if (relation) {
      acc.push(relation)
    }

    return acc
  }, [])
}
